import React from "react";
import styled from "styled-components";
import { Jumbotron } from "reactstrap";

const AboutText = styled.div`
  color: #393f4d;
  font-size: 18px;
  margin: 20px;
`;

const About = props => {
  return (
    <AboutText>
      <Jumbotron>
        {/* <p className="lead">Top Class in Glass</p>
        <hr className="my-2" /> */}
        <p>
          Red River Glazing is a commercial and residential glass company with offices in Fargo and Bismarck, North Dakota. We help contractors and customers around the country build their dream store fronts, custom shower enclosures, mirrors, and many other glass products.
        </p>

        <p>
          Our company was established in June 1999 with two employees working out of the owner’s Fargo home and garage. Over the last 18 years, River Glazing has grown tremendously, now employing nearly 50 people year-round.
        </p>

        <p>
          This growth has enabled us to move beyond our original storefront focus. Our expanded services include mirrors, glass shower enclosures, railings, partitions, shelves and many other specialty services. This expanded scope also led us to open a second office in Bismarck in 2013. With two offices, we are able to better serve North Dakota and beyond.
        </p>

        <p>
          Even though Red River Glazing has grown, we always keep in mind that we can only be as successful as our customers and employees. As such:
          <ul>
          <li>We strive every day to produce superior products and services at competitive prices;</li>
          <li>We aim to be the best at fabrication, installation, and supplier for all of our products;</li>
          <li>We choose to treat all customers with the same amount of duty and care, regardless of size, industry, or location. We work with single homeowners, large contractors, and everything in between;</li>
          <li>We respect our employees, because they are the best at what they do; This mindset allows Red River Glazing to continue to grow and provide excellent service to all customers.</li>
          </ul>
        </p>
          {/* <p className="lead">
          <Button color="primary">Learn About Our Team</Button>
        </p> */}
      </Jumbotron>
    </AboutText>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/About.js